import { render, staticRenderFns } from "./SuperAdminCourseSettings.vue?vue&type=template&id=e4e5e908&scoped=true"
import script from "./SuperAdminCourseSettings.vue?vue&type=script&lang=js"
export * from "./SuperAdminCourseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e5e908",
  null
  
)

export default component.exports